"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createDefaultStore = function createDefaultStore() {
  var storedValue = null;

  return {
    swap: function swap(f) {
      storedValue = f(storedValue);
    },
    set: function set(value) {
      storedValue = value;
    },
    get: function get() {
      return storedValue;
    }
  };
};

exports.default = createDefaultStore;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-impression-tracking/build/createDefaultStore.js
 ** module id = 48
 ** module chunks = 0
 **/